import { useState } from 'react';
import type { VideoAsset } from '../../../services/admin/adminBackendServiceVideoLibraryMixin';

/** Confirm-then-delete state for one video at a time in a list (only one confirm bar open). */
export function useVideoDeleteConfirm(onRemove: (video: VideoAsset) => Promise<void>) {
  const [confirmId, setConfirmId] = useState<string | null>(null);
  const [deleting, setDeleting] = useState(false);
  const [deleteError, setDeleteError] = useState<string | null>(null);

  const cancelDelete = () => {
    setConfirmId(null);
    setDeleteError(null);
  };

  const confirmDelete = async (video: VideoAsset) => {
    setDeleting(true);
    setDeleteError(null);
    try {
      await onRemove(video);
      setConfirmId(null);
    } catch (err) {
      setDeleteError(
        (err as { error?: string; message?: string })?.error ??
          (err as Error)?.message ??
          'Could not delete this video.',
      );
    } finally {
      setDeleting(false);
    }
  };

  return { confirmId, setConfirmId, deleting, deleteError, cancelDelete, confirmDelete };
}
